import {useState, useRef} from 'react';
import classNames from "classnames";
import { useClickOutside } from '../hooks/useClickOutside';
import { useGoogleTranslate } from '../hooks/useGoogleTranslate';
import { selectCulture } from '../utils/googleTranslateUtil';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from "@fortawesome/free-solid-svg-icons"; 

const Languages = ()=>{
    
    const langRef = useRef(null);
    const [showLangList, setShowLangList] = useState(false);
    const { currentLang } = useGoogleTranslate();

    useClickOutside([langRef], () => setShowLangList(false));

    // Persists the picked culture into this app's own cookie before letting the
    // click's normal navigation to "?lang=<culture>" proceed - see selectCulture()
    // and CULTURE_COOKIE_NAME for why this cookie must stay independent of any other
    // RHP site sharing the domain.
    const handleLangSelect = (e) => {
        const anchor = e.target.closest('a[href]');
        if (!anchor) return;
        const culture = new URLSearchParams(anchor.getAttribute('href').split('?')[1] || '').get('lang');
        selectCulture(culture);
    };
    
    return (
        <>
            <div id="google_translate_element" className="notranslate" style={{display:'none'}}></div>
            <div ref={langRef} className={classNames("language-selector notranslate", {'on': showLangList})} translate="no">
                <p className="curr-lang"><a onClick={(e)=>{e.preventDefault();setShowLangList(!showLangList)}} href="#" title="English"><span className="txt">{currentLang.toUpperCase()}</span><FontAwesomeIcon icon={faCaretDown} /></a></p>
                <ul onClick={handleLangSelect}>
                    <li><a data-lang-val="en" href="?lang=en-EN" title="English">en</a></li>
                    <li><a data-lang-val="es" href="?lang=es-ES" title="Spanish">es</a></li>
                    <li><a data-lang-val="de" href="?lang=de-DE" title="German">de</a></li>
                    <li><a data-lang-val="nl" href="?lang=nl-NL" title="Dutch">nl</a></li>
                    <li><a data-lang-val="it" href="?lang=it-IT" title="Italian">it</a></li>
                    <li><a data-lang-val="fr" href="?lang=fr-FR" title="French">fr</a></li>
                    <li><a data-lang-val="pt" href="?lang=pt-PT" title="Portuguese">pt</a></li>
                    <li><a data-lang-val="th" href="?lang=th-TH" title="Thai">th</a></li>
                    <li><a data-lang-val="id" href="?lang=id-ID" title="Indonesian">id</a></li>
                    <li><a data-lang-val="vi" href="?lang=vi-VN" title="Vietnamese">vi</a></li>
                </ul>
            </div>
        </>
        
    )
}

export default Languages;